import { render, staticRenderFns } from "./QuotesListFilter.vue?vue&type=template&id=5588c224&"
import script from "./QuotesListFilter.vue?vue&type=script&lang=js&"
export * from "./QuotesListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports